/* eslint max-classes-per-file: 0 */

import {
  Subject as Data,
  SubjectCollection as Collection,
} from '@/typings/api/CollectorPublication'

import { BaseCollectorApiAuth } from '@/api/BaseApiAuth'

export class SubjectsApi extends BaseCollectorApiAuth<Data, Collection> {
  protected readonly endpoint = 'subjects';

  protected readonly hasFinishSlash = false;
}
